const ITEMS = [
  "Prevención de riesgos",
  "Salud ocupacional",
  "Protección personal certificada",
  "Heredia · Costa Rica",
  "23 años de experiencia",
  "Marcas líderes mundiales",
];

export default function Ticker() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-ticker"
      className="relative overflow-hidden border-y border-white/10"
      style={{ backgroundColor: "hsl(var(--pv-deep-green))" }}
    >
      <div className="flex w-max items-center animate-marquee-slow py-5 lg:py-7">
        {row.map((t, i) => (
          <div key={i} className="flex shrink-0 items-center">
            <span
              className={`px-6 lg:px-10 font-display font-extrabold uppercase tracking-tight text-2xl lg:text-4xl whitespace-nowrap ${
                i % 2 ? "text-outline" : "text-white/90"
              }`}
            >
              {t}
            </span>
            <span className="h-2.5 w-2.5 shrink-0 rotate-45 bg-pv-orange" />
          </div>
        ))}
      </div>
    </div>
  );
}
